import React from "react";

import {
  Create,
  TextInput,
  SimpleForm,
  useNotify,
  useRefresh,
  useRedirect,
  BooleanInput,
  DateInput,
  NumberInput,
  SelectInput,
} from "react-admin";

import { Box, Grid, Item } from "@material-ui/core";

import { useCreateStyles } from "../__common/MyStyles";
import { MyCreateActions } from "../__common/MyCreateActions";
import { sleep } from "../../common/js/Functions";

export const AntibioticsCreate = (props) => {
  const classes = useCreateStyles();

  const notify = useNotify();
  const refresh = useRefresh();
  const redirect = useRedirect();

  const [showContinuousAtttibutes, setContinuousResults] = React.useState(true);

  const onChange = () => setContinuousResults(!showContinuousAtttibutes);

  const onSuccess = () => {
    notify(`Antibiotics created`);
    sleep(2000).then(() => {
      redirect("/antibiotics");
      refresh();
    });
  };

  const ContinuousFields = () => (
    <Grid
      container
      spacing={2}
      direction="row"
      justifyContent="flex-start"
      alignItems="flex-start"
    >
      <Grid item xs={12}>
        <div className="title-subsection">ANTIBIOTICS MICS</div>
      </Grid>
      <Box width="100%" /> {/* empty space */}
      <Grid item xs={12}>
        <div className="">MIC Susceptible</div>
      </Grid>
      <Grid item xs={3}>
        <SelectInput
          label=""
          source="mic_susceptible_op"
          choices={[
            { id: "lt", name: "<" },
            { id: "le", name: "<=" },
            { id: "eq", name: "=" },
            { id: "ne", name: "!=" },
            { id: "ge", name: ">" },
            { id: "gt", name: ">=" },
          ]}
          fullWidth
        />
      </Grid>
      <Grid item xs={3}>
        <NumberInput source="mic_susceptible" fullWidth />
      </Grid>
      <Box width="100%" /> {/* empty space */}
      <Grid item xs={3}>
        <SelectInput
          label=""
          source="mic_intermediate_op"
          choices={[
            { id: "lt", name: "<" },
            { id: "le", name: "<=" },
            { id: "eq", name: "=" },
            { id: "ne", name: "!=" },
            { id: "ge", name: ">" },
            { id: "gt", name: ">=" },
          ]}
          fullWidth
        />
      </Grid>
      <Grid item xs={3}>
        <NumberInput source="mic_intermediate" fullWidth />
      </Grid>
      <Box width="100%" /> {/* empty space */}
      <Grid item xs={3}>
        <SelectInput
          label=""
          source="mic_resistant_breakpoint_op"
          choices={[
            { id: "lt", name: "<" },
            { id: "le", name: "<=" },
            { id: "eq", name: "=" },
            { id: "ne", name: "!=" },
            { id: "ge", name: ">" },
            { id: "gt", name: ">=" },
          ]}
          fullWidth
        />
      </Grid>
      <Grid item xs={3}>
        <NumberInput source="mic_resistant_breakpoint" fullWidth />
      </Grid>
    </Grid>
  );

  return (
    <Create
      title="Create Antibiotics"
      undoable={false}
      onSuccess={onSuccess}
      submitOnEnter={true}
      actions={<MyCreateActions />}
      classes={classes}
      {...props}
    >
      <SimpleForm>
        <Grid
          container
          spacing={2}
          direction="row"
          justifyContent="flex-start"
          alignItems="flex-start"
        >
          <Grid item xs={6}>
            <TextInput source="name" fullWidth />
          </Grid>
          <Box width="100%" /> {/* empty space */}
          <Grid item xs={3}>
            <DateInput locales="es-UY" source="start_date" fullWidth />
          </Grid>
          <Grid item xs={3}>
            <DateInput locales="es-UY" source="end_date" fullWidth />
          </Grid>
          <Box width="100%" /> {/* empty space */}
          <Grid item xs={12} sm={6} md={3}>
            <BooleanInput source="is_discrete" onChange={onChange} />
          </Grid>
          <Box width="100%" /> {/* empty space */}
        </Grid>

        {showContinuousAtttibutes ? <ContinuousFields /> : null}

        <Grid
          container
          spacing={2}
          direction="row"
          justifyContent="flex-start"
          alignItems="flex-start"
        >
          <Box width="100%" /> {/* empty space */}
          <Grid item xs={12} sm={6} md={9}>
            <TextInput
              fullWidth
              source="notes"
              label="Notes"
              multiline
              minRows={6}
            />
          </Grid>
        </Grid>
      </SimpleForm>
    </Create>
  );
};
